import Vue from "vue";
import VueRouter from "vue-router";
import Multiedro from "../views/Multiedro.vue";
import Login from "../views/Login.vue";
import Clientes from "../views/Clientes.vue";
import Multisign from "../views/Multisign.vue";
import Usuarios from "../views/Usuarios.vue";
import Configuracoes from "../views/Configuracoes.vue";
import Agendamentos from "../views/Agendamentos.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/multiedro",
    name: "Multiedro",
    component: Multiedro,
  },
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/clientes",
    name: "Clientes",
    component: Clientes,
  },
  {
    path: "/multisign",
    name: "Multisign",
    component: Multisign,
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    props: (route) => ({ id: route.query.id }),
    component: Usuarios,
  },
  {
    path: "/configuracoes",
    name: "Configuracoes",
    component: Configuracoes,
  },
  {
    path: "/agendamentos",
    name: "Agendamentos",
    component: Agendamentos
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  let usuarioEstaLogado = localStorage.getItem("usuarioLogado") != null;

  if (to.fullPath == "/") {
    if (usuarioEstaLogado) next("/multiedro");
    else next();
  } else {
    if (usuarioEstaLogado) next();
    else next("/");
  }

  if (to.name == null) {
    if (usuarioEstaLogado) next("/multiedro");
    else
      next({
        path: "/",
      });
  }

  next();
});

export default router;
